import { createContext } from "react";

const FirebaseContext = createContext<any | null>(null);
export default FirebaseContext;